import { Suspense } from "react";
import { renderRoutes } from "react-router-config";

const LayoutDefault = props => {

    const { route } = props;

    return(
        <div>
            <Suspense fallback={<div>Loading...</div>}>
                {renderRoutes(route.routes)}
            </Suspense>
        </div>
    )
}

export default LayoutDefault;